/**
 * <engraving-field> — mirrors a visible text input into a hidden line-item
 * property, keeps a live character count, and optionally shows a preview of
 * how the engraving will read on the plate.
 *
 * The hidden input stays disabled while the field is empty so blank engravings
 * are never submitted with the order.
 */
if (!customElements.get('engraving-field')) {
  class EngravingField extends HTMLElement {
    connectedCallback() {
      this.source = this.querySelector('[data-engraving-source]');
      this.target = this.querySelector('[data-engraving-target]');
      this.counter = this.querySelector('[data-engraving-count]');
      this.preview = this.querySelector('[data-engraving-preview]');
      this.max = parseInt(this.dataset.max, 10) || 15;
      this.uppercase = this.dataset.uppercase === 'true';

      if (!this.source || !this.target) return;

      this.onInput = this.onInput.bind(this);
      this.source.addEventListener('input', this.onInput);
      this.onInput();
    }

    disconnectedCallback() {
      if (this.source) this.source.removeEventListener('input', this.onInput);
    }

    onInput() {
      let value = this.source.value;
      if (this.uppercase) value = value.toUpperCase();

      const trimmed = value.trim();
      this.target.value = trimmed;
      this.target.disabled = trimmed.length === 0;

      if (this.counter) {
        this.counter.textContent = `${value.length}/${this.max}`;
        this.counter.dataset.over = value.length >= this.max ? 'true' : 'false';
      }

      if (this.preview) this.preview.textContent = value;
    }
  }

  customElements.define('engraving-field', EngravingField);
}
